import type { ReactNode } from "react";

const P = (d: string, k: number) => <path key={k} d={d} />;

function svg(parts: ReactNode[]) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {parts}
    </svg>
  );
}

export const ICONES = {
  pilotage: svg([P("M3 13h4l3 7 4-16 3 9h4", 0)]),
  opportunites: svg([P("M4 20V9m5 11V5m5 15v-8m5 8V8", 0)]),
  catalogue: svg([P("M4 7h16M4 12h16M4 17h10", 0), P("M4 7v10", 1)]),
  listes: svg([P("M6 3h9l4 4v14H6z", 0), P("M9 11h7M9 15h7M9 7h4", 1)]),
  packaging: svg([P("M12 3l8 4.3v9.4L12 21l-8-4.3V7.3z", 0), P("M4 7.3L12 12l8-4.7M12 12v9", 1)]),
  qualite: svg([
    P("M12 3l7 3v6c0 4.2-2.9 7.6-7 9-4.1-1.4-7-4.8-7-9V6z", 0),
    P("M9 12l2.2 2.2L15.5 10", 1),
  ]),
  usines: svg([P("M3 21V10l5 3V10l5 3V7l8 4v10z", 0), P("M7 17h2m4 0h2m4 0h0", 1)]),
  agents: svg([
    <circle key="c" cx="9" cy="8" r="3.2" />,
    P("M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5", 1),
    P("M16 11.2a3 3 0 100-6", 2),
    P("M17.5 14.8c2 .6 3.5 2.4 3.5 5.2", 3),
  ]),
  sante: svg([P("M3 12h3l2-5 3 10 2.5-7 2 4h5.5", 0)]),
  importer: svg([P("M12 3v10", 0), P("M8 9.5l4 4 4-4", 1), P("M4 16v4h16v-4", 2)]),
  ventes: svg([P("M5 4h11l3 3v13H5z", 0), P("M8 10h8M8 14h8M8 18h5", 1)]),
  devis: svg([P("M5 4h9l3 3v5", 0), P("M5 4v16h7", 1), P("M8 10h5M8 14h3", 2), P("M18 15v6M15 18h6", 3)]),
  modeles: svg([P("M4 5h16v4H4z", 0), P("M4 13h7v6H4z", 1), P("M15 13h5M15 16h5M15 19h3", 2)]),
  facturation: svg([P("M6 3h12v18l-3-2-3 2-3-2-3 2z", 0), P("M9 8h6M9 12h6M9 16h3", 1)]),
  clients: svg([
    P("M4 20v-1.5c0-2.5 2.5-4 5.5-4s5.5 1.5 5.5 4V20", 0),
    <circle key="c" cx="9.5" cy="7.5" r="3.3" />,
    P("M17 20v-1.2c0-1.6-.9-2.9-2.2-3.6", 2),
    P("M16 5.2a3 3 0 010 5.6", 3),
  ]),
  commissions: svg([
    <circle key="c" cx="12" cy="12" r="8.5" />,
    P("M15 9.2A3 3 0 009.4 10c0 2.6 5.2 1.4 5.2 4a3 3 0 01-5.6.8", 1),
    P("M12 6.4v1.4M12 16.2v1.4", 2),
  ]),
  recherche: svg([<circle key="c" cx="10.5" cy="10.5" r="6.5" />, P("M20 20l-4.8-4.8", 1)]),
  filtre: svg([P("M4 5h16l-6.2 7.2V19l-3.6 2v-8.8z", 0)]),
  cadenas: svg([
    <rect key="r" x="5" y="11" width="14" height="9" rx="2" />,
    P("M8 11V8a4 4 0 018 0v3", 1),
  ]),
  info: svg([<circle key="c" cx="12" cy="12" r="9" />, P("M12 11v5", 1), P("M12 8h.01", 2)]),
  oeil: svg([
    P("M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z", 0),
    <circle key="p" cx="12" cy="12" r="3" />,
  ]),
  fermer: svg([P("M6 6l12 12M18 6L6 18", 0)]),
  menu: svg([P("M4 7h16M4 12h16M4 17h16", 0)]),
  soleil: svg([
    <circle key="c" cx="12" cy="12" r="4" />,
    P("M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19", 1),
  ]),
  lune: svg([P("M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z", 0)]),
  plus: svg([P("M12 5v14M5 12h14", 0)]),
  envoyer: svg([P("M4 12l16-7-7 16-2-7z", 0)]),
  retour: svg([P("M15 18l-6-6 6-6", 0)]),
  sortir: svg([P("M14 4h4a2 2 0 012 2v12a2 2 0 01-2 2h-4", 0), P("M10 16l-4-4 4-4", 1), P("M6 12h10", 2)]),
  note: svg([P("M5 4h14v10l-5 6H5z", 0), P("M14 20v-6h5", 1), P("M8 9h8M8 13h4", 2)]),
  horloge: svg([<circle key="c" cx="12" cy="12" r="8.5" />, P("M12 7.5V12l3.2 2", 1)]),
  coche: svg([P("M4.5 12.5l5 5L20 7", 0)]),
  corbeille: svg([
    P("M4 7h16", 0),
    P("M9 7V5h6v2", 1),
    P("M6 7l1 13h10l1-13", 2),
    P("M10 11v6M14 11v6", 3),
  ]),
  crayon: svg([P("M4 20l3.5-.8L20 6.7a2 2 0 00-2.8-2.8L4.8 16.5z", 0), P("M15.5 5.5l3 3", 1)]),
} as const;

export type NomIcone = keyof typeof ICONES;

export function Icon({ n, cls = "glyph" }: { n: NomIcone; cls?: string }) {
  return <span className={cls}>{ICONES[n]}</span>;
}
